<div class="w-1/2">

    <ul class="mt-10 flex flex-col gap-5">


        <!-- <pre>{{ (courseStructure$ | async) | json }}</pre> -->

        @for (parent of courseStructureData || [] ; let parentIndex = $index; track $index) {
        <li class="main_node" [ngClass]="{'new':parent?.flag === 1}">
            <div class=" flex gap-3 items-start group">
                <button class="btn btn-xs btn-circle bg-white" [disabled]="parent?.flag === 1"
                    (click)="toggleNode(1,1,parentIndex,null,null,null,'visible')"><i
                        class="ri-arrow-drop-down-line"></i></button>
                <div class="inline-flex items-center gap-2  p-2 px-4 rounded-lg -mt-2 text-zinc-500">

                    <span class="font-semibold cursor-pointer group-hover:text-black"
                        (click)="toggleNode(1,1,parentIndex,null,null,null,'visible')">{{parent?.structure_name}}</span>

                </div>
            </div>

            @if (parent?.isOpen) {
            <div class="content">
                <div class="" [ngClass]="{'min-h-[5rem]':parent?.flag !== 1}">
                    <ul class=" my-3 flex flex-col gap-5">

                        @for (child of parent?.child || [];let childIndex = $index ; track $index) {
                        <li class="child_node" [ngClass]="{'new':child?.flag === 1}">

                            <div class=" flex gap-3 items-start group">
                                <button class="btn btn-xs btn-circle bg-white" [disabled]="child?.flag === 1"
                                    (click)="toggleNode(1,2,parentIndex,childIndex,null,null,'visible')">
                                    <i class="ri-arrow-drop-down-line"></i></button>
                                <div class="inline-flex items-center gap-2 text-zinc-500 p-2 rounded-lg -mt-2">

                                    <span class="font-semibold cursor-pointer group-hover:text-black"
                                        (click)="toggleNode(1,2,parentIndex,childIndex,null,null,'visible')">{{child?.structure_name}}</span>

                                </div>
                            </div>

                            @if (child?.isOpen) {
                            <div class="content">
                                <div [ngClass]="{'min-h-[5rem]':child?.flag !== 1}">
                                    <ul class=" my-3 flex flex-col gap-5">

                                        @for (subchild of child?.grandChild || []; let subchildIndex = $index; track
                                        $index) {

                                        <li class="subchild_node" [ngClass]="{'new':subchild?.flag === 1}">

                                            <div class=" flex gap-3 items-start group">
                                                <button class="btn btn-xs btn-circle bg-white"
                                                    [disabled]="subchild?.flag === 1"
                                                    (click)="toggleNode(1,3,parentIndex,childIndex,subchildIndex,null,'visible')">
                                                    <i class="ri-arrow-drop-down-line"></i></button>
                                                <div
                                                    class="inline-flex items-center gap-2 p-2 text-zinc-500 rounded-lg -mt-2">

                                                    <span class="font-semibold cursor-pointer group-hover:text-black"
                                                        (click)="toggleNode(1,3,parentIndex,childIndex,subchildIndex,null,'visible')">{{subchild?.structure_name}}</span>

                                                </div>
                                            </div>
                                            @if (subchild?.isOpen) {
                                            <div class="content">
                                                <div [ngClass]="{'min-h-[2rem]':subchild?.flag !== 1}">
                                                    <ul class="my-3 flex flex-col gap-5 pl-9">

                                                        @if (subchild.structure_maps ) {
                                                        @for (structure_maps of subchild?.structure_maps;let
                                                        subchildStructureMapsIndex = $index; track $index)
                                                        {
                                                        <ng-container [ngSwitch]="structure_maps?.action_type">
                                                            <li *ngSwitchCase="'video'">
                                                                <div
                                                                    class="w-full bg-white p-3 border rounded-lg flex items-center gap-5 h-[10rem]">

                                                                    <div class="w-[15rem] h-full cursor-pointer"
                                                                        (click)="playVideo(structure_maps?.video)">
                                                                        <img class="h-full w-full object-cover rounded-md"
                                                                            src="{{structure_maps?.video?.thumbnail}}"
                                                                            alt="">
                                                                    </div>
                                                                    <ul class="w-full capitalize">
                                                                        <li class="grid grid-cols-2">
                                                                            <span
                                                                                class="uppercase text-sm text-zinc-500">Title
                                                                                :</span><span
                                                                                class="font-semibold line-clamp-2">{{structure_maps?.video?.video_title}}</span>
                                                                        </li>
                                                                        <li class="grid grid-cols-2">
                                                                            <span
                                                                                class="uppercase text-sm text-zinc-500">price
                                                                                :</span><span
                                                                                class="font-semibold">{{structure_maps?.video?.price}}</span>
                                                                        </li>
                                                                        <li class="grid grid-cols-2">
                                                                            <span
                                                                                class="uppercase text-sm text-zinc-500">No.
                                                                                of views :</span><span
                                                                                class="font-semibold">{{structure_maps?.video?.no_of_views}}</span>
                                                                        </li>
                                                                        <li class="grid grid-cols-2">
                                                                            <span
                                                                                class="uppercase text-sm text-zinc-500">Reel
                                                                                :</span><span
                                                                                class="font-semibold">{{structure_maps?.video?.is_reel_link}}</span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            <li *ngSwitchCase="'document'">

                                                            </li>

                                                        </ng-container>
                                                        }
                                                        }

                                                    </ul>
                                                </div>

                                                @if (subchild?.flag !== 1) {

                                                <div class="flex gap-3 items-center pl-0.5">
                                                    <span
                                                        class="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center z-40"><span
                                                            class="w-2.5 h-2.5 rounded-full bg-primary-500"></span></span>

                                                </div>
                                                }

                                            </div>
                                            }
                                        </li>
                                        }
                                        @if (child.structure_maps ) {
                                        @for (structure_maps of child?.structure_maps;let childStructureMapsIndex =
                                        $index; track $index) {
                                        <ng-container [ngSwitch]="structure_maps?.action_type">

                                            <li class="pl-9" *ngSwitchCase="'video'">
                                                <div
                                                    class="w-full bg-white p-3 border rounded-lg flex items-center gap-5 h-[10rem]">

                                                    <div class="w-[15rem] h-full cursor-pointer"
                                                        (click)="playVideo(structure_maps?.video)">
                                                        <img class="h-full w-full object-cover rounded-md"
                                                            src="{{structure_maps?.video?.thumbnail}}" alt="">
                                                    </div>
                                                    <ul class="w-full capitalize">
                                                        <li class="grid grid-cols-2">
                                                            <span class="uppercase text-sm text-zinc-500">Title
                                                                :</span><span
                                                                class="font-semibold line-clamp-2">{{structure_maps?.video?.video_title}}</span>
                                                        </li>
                                                        <li class="grid grid-cols-2">
                                                            <span class="uppercase text-sm text-zinc-500">price
                                                                :</span><span
                                                                class="font-semibold">{{structure_maps?.video?.price}}</span>
                                                        </li>
                                                        <li class="grid grid-cols-2">
                                                            <span class="uppercase text-sm text-zinc-500">No.
                                                                of views :</span><span
                                                                class="font-semibold">{{structure_maps?.video?.no_of_views}}</span>
                                                        </li>
                                                        <li class="grid grid-cols-2">
                                                            <span class="uppercase text-sm text-zinc-500">Reel
                                                                :</span><span
                                                                class="font-semibold">{{structure_maps?.video?.is_reel_link}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li class="pl-9" *ngSwitchCase="'document'">

                                            </li>

                                        </ng-container>
                                        }
                                        }


                                    </ul>
                                </div>

                                @if (child?.flag !== 1) {

                                <div class="flex gap-3 items-center mt-10 pl-0.5">
                                    <span
                                        class="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center z-40"><span
                                            class="w-2.5 h-2.5 rounded-full bg-primary-500"></span></span>

                                </div>
                                }

                            </div>
                            }
                        </li>
                        }

                        @if (parent.structure_maps ) {
                        @for (structure_maps of parent?.structure_maps;let parentStructureMapsIndex = $index; track
                        $index) {
                        <ng-container [ngSwitch]="structure_maps?.action_type">

                            <li class="pl-9" *ngSwitchCase="'video'">
                                <div class="w-full bg-white p-3 border rounded-lg flex items-center gap-5 h-[10rem]">

                                    <div class="w-[15rem] h-full cursor-pointer"
                                        (click)="playVideo(structure_maps?.video)">
                                        <img class="h-full w-full object-cover rounded-md"
                                            src="{{structure_maps?.video?.thumbnail}}" alt="">
                                    </div>
                                    <ul class="w-full capitalize">
                                        <li class="grid grid-cols-2">
                                            <span class="uppercase text-sm text-zinc-500">Title
                                                :</span><span
                                                class="font-semibold line-clamp-2">{{structure_maps?.video?.video_title}}</span>
                                        </li>
                                        <li class="grid grid-cols-2">
                                            <span class="uppercase text-sm text-zinc-500">price
                                                :</span><span
                                                class="font-semibold">{{structure_maps?.video?.price}}</span>
                                        </li>
                                        <li class="grid grid-cols-2">
                                            <span class="uppercase text-sm text-zinc-500">No.
                                                of views :</span><span
                                                class="font-semibold">{{structure_maps?.video?.no_of_views}}</span>
                                        </li>
                                        <li class="grid grid-cols-2">
                                            <span class="uppercase text-sm text-zinc-500">Reel
                                                :</span><span
                                                class="font-semibold">{{structure_maps?.video?.is_reel_link}}</span>
                                        </li>
                                    </ul>
                                </div>

                            </li>

                            <li class="pl-9" *ngSwitchCase="'document'">

                            </li>

                        </ng-container>
                        }
                        }
                    </ul>
                </div>

                @if (parent?.flag !== 1) {
                <div class="flex gap-3 items-center mt-10 pl-0.5">
                    <span class="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center z-40"><span
                            class="w-2.5 h-2.5 rounded-full bg-primary-500"></span></span>

                </div>
                }

            </div>
            }
        </li>
        }
    </ul>






</div>
